<template>
	<div class="page-content list-page push-sender">
		<div class="page-content-header with-button">
			<div class="page-title">
				Push notifications
			</div>
		</div>
		<div class="page-content-white">
			<form class="search-form" @submit.prevent="send">
				<div class="form-group">
					<label for="title">Message title:</label>
					<textarea id="title"
					          v-model="title"
					          name="title"
							  class="grey-input form-control"
					></textarea>
				</div>
				<div class="form-group mx-3">
					<label for="message">Message text:</label>
					<textarea id="message"
					          name="message"
					          v-model="message"
							  class="grey-input form-control"
					></textarea>
				</div>
				<button class="button button-primary">Send</button>
			</form>

			<div class="table-responsive">
				<h4 v-show="loading">Loading…</h4>
				<table class="table list-table">
					<thead>
						<tr>
							<th>#ID</th>
							<th>Customer name</th>
							<th>Created</th>
							<th>Phone</th>
							<th>Email</th>
							<th>User status</th>
							<th>
								<input type="checkbox" v-model="selectedAll" v-on:change="selectAll()">
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="user in items" :key="user.id">
							<td class="text-danger">#{{user.id}}</td>
							<td>
								<a :href="'/users/edit/'+ user.id" class="action edit" target="_blank">
									<i class="hs-icon hs-icon-writing"></i>
									{{user.full_name}}
								</a>
							</td>
							<td>{{user.created_at_formatted}}</td>
							<td class="text-danger">{{user.phone}}</td>
							<td>{{user.email}}</td>
							<td>
								<strong v-show="user.is_active" class="text-success">Active</strong>
								<strong v-show="!user.is_active" class="text-grey">Disabled</strong>
							</td>
							<td>
								<input type="checkbox" v-model="user.selected">
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "PushSender",
		mounted() {
			this.getList()
		},
		data(){
			return {
				selectedAll: false,
				loading: false,
				message: '',
				title: '',
				items: []
			}
		},
		methods: {
			selectAll(){
				for(let i = 0; i < this.items.length; i++){
					this.items[i].selected = this.selectedAll;
				}
			},
			getList(){
				this.loading = true;

				axios.get('/users/list', this.filters).then((r) => {
					this.items = r.data;
					this.$forceUpdate();
					this.loading = false;
				})
			},
			send(){
				let itemsIds = this.items.filter((m) => {
					return m.selected
				}).map((m) => {
					return m.id
				});

				if (itemsIds.length == 0) {
					return;
				}

				$.confirm({
					title: '',
					content: `<div style="font-size: 1.3em">Are you sure want to send push notification to selected customers?</div>`,
					buttons: {
						confirm: {
							text: 'Ok',
							btnClass: 'btn btn-success',
							keys: ['enter'],
							action: () => {
								axios.post('/users/sendPush', {
									ids: itemsIds,
									title: this.title,
									message: this.message,
								}).then((r) => {
									this.getList();
									this.loading = false;

									this.$dlg.toast('Push notifications sent!',{
										title: '',
										messageType: 'info',
										closeTime: 2 //auto close dialog time(second)
									});
								})
							}
						},
						cancel: {
							text: 'Cancel',
							btnClass: 'btn btn-danger',
							keys: ['esc', 'escape'],
						},
					}
				})
			}

		}
	}
</script>

<style scoped>

</style>
